<template>
  <div class="h-2 pin-r absolute flex mr-2">
    <div
      class="p-2 w-2 h-2 border-b border-black cursor-pointer mr-2"
      :class="{ 'border-blue': light }"
      @click="$emit('minimize')"
    />
    <div
      class="p-2 w-2 h-2 border border-black cursor-pointer"
      :class="{ 'border-blue': light }"
      @click="$emit('maximize')"
    />
  </div>
</template>

<script>
export default {
  name: 'ButtonBar',

  props: {
    light: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
